import type { Template } from "@/types";

export const SQ_02_H2_V0: Template[] = [
    {
        id: "sq-02-h2v0-01",
        name: "SQ 01 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 142, y: 170, width: 527, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 170, width: 527, height: 381, rotation: 0, imageRotation: 0 },
            
        ],
    },

    {
        id: "sq-02-h2v0-02",
        name: "SQ 02 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 96, y: 170, width: 527, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 813, y: 170, width: 527, height: 381, rotation: 0, imageRotation: 0 },
          
        ],
    },

    {
        id: "sq-02-h2v0-03",
        name: "SQ 03 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 137, width: 665, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 137, width: 664, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h2v0-04",
        name: "SQ 04 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 120, width: 713, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 120, width: 713, height: 476, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h2v0-05",
        name: "SQ 05 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 274, y: 213, width: 440, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 213, width: 439, height: 292, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h2v0-06",
        name: "SQ 06 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 140, y: 214, width: 440, height: 293, rotation: 0, imageRotation: 0 },
            { id: "2", x: 764, y: 150, width: 632, height: 421, rotation: 0, imageRotation: 0 },

        ],
    },

    {
        id: "sq-02-h2v0-07",
        name: "SQ 07 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 209, y: 170, width: 567, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 784, y: 170, width: 567, height: 376, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h2v0-08",
        name: "SQ 08 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 84, y: 170, width: 567, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 659, y: 170, width: 567, height: 376, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-02-h2v0-09",
        name: "SQ 09 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 68, y: 207, width: 495, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 595, y: 102, width: 777, height: 516, rotation: 0, imageRotation: 0 },

        ],
    },

    {
        id: "sq-02-h2v0-10",
        name: "SQ 10 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 102, width: 777, height: 516, rotation: 0, imageRotation: 0 },
            { id: "2", x: 873, y: 207, width: 495, height: 305, rotation: 0, imageRotation: 0 },

        ],
    },

    {
        id: "sq-02-h2v0-11",
        name: "SQ 11 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 43, width: 952, height: 633, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1007, y: 248, width: 363, height: 224, rotation: 0, imageRotation: 0 },

        ],
    },

    {
        id: "sq-02-h2v0-12",
        name: "SQ 12 - H2V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-02-h2_v0_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 50, y: 234, width: 412, height: 252, rotation: 0, imageRotation: 0 },
            { id: "2", x: 498, y: 65, width: 886, height: 590, rotation: 0, imageRotation: 0 },

        ],
    },
];
